import React, { useState, useEffect } from "react";
import "./PreOrder.css";
import { loadStripe } from "@stripe/stripe-js";

import TextInput from "./TextInput";
import AddressInput from "./AddressInput";

const stripePromise = loadStripe("pk_test_51MRw4WBziuKXXIvwZZRnJwKviwWGpspaZSWb4xzVQftlUDpU4AmFv8H0n81Yo5FrhfVvbuO62gXRBdtycWa4B07000kRP9vhDD")
const productPriceId = 'price_1MsgLCBziuKXXIvwv4Abc0UD'

const PreOrder: React.FC = () => {
  // State variables to store order form data
  const [name, setName] = useState("Name");
  const [email, setEmail] = useState("Email");
  const [address, setAddress] = useState("Street address");
  const [suburb, setSuburb] = useState("Suburb");
  const [state, setState] = useState("State");
  const [postcode, setPostcode] = useState("Postcode");
  // State variable for error messages
  const [message, setMessage] = useState("")
  
  // State variable to store quantity
  const [quantity, setQuantity] = useState("1")
  // Functions to increment or decrement quantity
  const increment = () => {
    if (parseInt(quantity) < 99) {
      setQuantity((parseInt(quantity) + 1).toString())
    }
  }
  const decrement = () => {
    if (parseInt(quantity) > 1) {
      setQuantity((parseInt(quantity) - 1).toString())
    }
  }
  // Function to update quantity when user types in input
  const updateQuantity = (value: string) => {
    // Ensure that the input is a number and greater than 0
    if (parseInt(value) > 0) {
      if (parseInt(value) > 100) { setQuantity("99") } else { setQuantity(value) }
    } else {
      setQuantity("1")
    }
  }
  // Handle address autocomplete
  const handlePlaceSelected = (place: any) => {
    let number = ""
    let street = ""
    let apartment = ""

    for (const component of place.address_components) {
      const componentType = component.types[0]
      switch (componentType) {
        case "street_number": {
          number = component.short_name
          break
        }
        case "route": {
          street = component.long_name
          break
        }
        case "subpremise": {
          apartment = component.short_name
          break
        }
        case "locality": {
          setSuburb(component.long_name)
          break
        }
        case "administrative_area_level_1": {
          setState(component.short_name)
          break
        }
        case "postal_code": {
          setPostcode(component.long_name)
          break
        }
      }
    }
    if (apartment !== "") {
      setAddress(apartment + "/" + number + " " + street)
    } else {
      setAddress(number + " " + street)
    }
  }

  const validateForm = () => {
    let valid = true

    if (name === "" || name === "Name") { 
      document.getElementById("Name")!.style.border = "1px solid #920000"
      valid = false
    } else {
      document.getElementById("Name")!.style.border = "1px solid #d9d8d62d"
    }
    if (email === "" || email === "Email") { 
      document.getElementById("Email")!.style.border = "1px solid #920000"
      valid = false
    } else {
      document.getElementById("Email")!.style.border = "1px solid #d9d8d62d"
    }
    if (address === "" || address === "Street address") { 
      document.getElementById("Street address")!.style.border = "1px solid #920000"
      valid = false
    } else {
      document.getElementById("Street address")!.style.border = "1px solid #d9d8d62d"
    }
    if (suburb === "" || suburb === "Suburb") { 
      document.getElementById("Suburb")!.style.border = "1px solid #920000"
      valid = false
    } else {
      document.getElementById("Suburb")!.style.border = "1px solid #d9d8d62d"
    }
    if (state === "" || state === "State") { 
      document.getElementById("State")!.style.border = "1px solid #920000"
      valid = false
    } else {
      document.getElementById("State")!.style.border = "1px solid #d9d8d62d"
    }
    if (postcode === "" || postcode === "Postcode") { 
      document.getElementById("Postcode")!.style.border = "1px solid #920000"
      valid = false
    } else {
      document.getElementById("Postcode")!.style.border = "1px solid #d9d8d62d"
    }

    // Verify email address with regex
    const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (emailRegex.test(email)) {
      document.getElementById("Email")!.style.border = "1px solid #d9d8d62d"
    } else {
      document.getElementById("Email")!.style.border = "1px solid #920000"
      valid = false
    }

    // Verify postcode with regex
    const postcodeRegex = /^[0-9]{4}$/
    if (postcodeRegex.test(postcode)) {
      document.getElementById("Postcode")!.style.border = "1px solid #d9d8d62d"
    }
    else {
      document.getElementById("Postcode")!.style.border = "1px solid #920000"
      valid = false
    }

    return valid
  }

  const stripeCheckout = async () => {
    if (validateForm()) {
      // Load the Stripe instance
      const stripe = await stripePromise;
  
      // Send the quantity to backend to create a Checkout session
      const response = await fetch("http://ec2-54-252-68-204.ap-southeast-2.compute.amazonaws.com:3001/create-checkout-session", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          quantity: parseInt(quantity),
          productPriceId: productPriceId,
          email: email,
          name: name,
          address: address,
          suburb: suburb,
          state: state,
          postcode: postcode,
        }),
      })
  
      const session = await response.json()
  
      // Redirect the user to the Checkout page
      await stripe?.redirectToCheckout({
        sessionId: session.id,
      })
    } else {
      // Provide feedback to the user that some fields are missing or invalid
      setMessage("Please ensure all fields are filled out appropriately.")
    }
  }

  useEffect(() => {
    // Check to see if this is a redirect back from Checkout
    const query = new URLSearchParams(window.location.search);

    if (query.get("success")) {
      setMessage("Order placed! You will receive an email confirmation.");
    }

    if (query.get("canceled")) {
      setMessage(
        "Order canceled -- please checkout once you're ready."
      );
    }
  }, []);

  return (
    <div className="PreOrderContainer" id="PreOrderContainer">
      <div className="PreOrderWrapper">

        <div className="Header">
          Pre-Order first batch
        </div>

        <TextInput defaultText="Name" inputState={name} setInputState={setName} />
        <TextInput defaultText="Email" inputState={email} setInputState={setEmail} />
        {/* <AddressInput onPlaceSelected={handlePlaceSelected} defaultText="Street address" inputState={address} setInputState={setAddress} /> */}
        <TextInput defaultText="Street address" inputState={address} setInputState={setAddress} />
        <TextInput defaultText="Suburb" inputState={suburb} setInputState={setSuburb}/>
        <TextInput defaultText="State" inputState={state} setInputState={setState} />
        <TextInput defaultText="Postcode" inputState={postcode} setInputState={setPostcode} />

        <div style={{height: '1em'}} />

        <div className="ProductDisplay">
          <div className="ProductImage" />
          <div className="P" style={{width: "10em"}}>
            OM1 Hair Balm: $20.00
          </div>
        </div>

        <div className="CheckoutFooter">
          <div className="CheckoutButton" onClick={stripeCheckout}>
            Checkout
          </div>
          <div style={{width: '2em'}} />
          <div className="P">
            Qty:
          </div>
          <div style={{width: '1em'}} />
          <div className="CheckoutButton" onClick={decrement}>
            -
          </div>
          <input 
            className="QuantityInput" 
            type="text" value={quantity}
            onChange={event => setQuantity(event.target.value)}
            onBlur={event => updateQuantity(event.target.value)}
          /> 
          <div className="CheckoutButton" onClick={increment}>
            +
          </div>
        </div>

        <p style={{color: 'red'}}>
          {message}
        </p>

      </div>
    </div>
  )
}
export default PreOrder
